import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dinamic-indicator-display',
  templateUrl: './dinamic-indicator-display.component.html',
  styleUrls: ['./dinamic-indicator-display.component.scss']
})
export class DinamicIndicatorDisplayComponent implements OnInit {
  @Input() indicatorName!: string;
  @Input() color!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
